import { EasmScanConfigurationAssetGridController } from '../controller/EasmScanConfigurationAssetGridController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';

export class EasmScanConfigurationAssetGridWebComponent extends BaseWebComponentElement {
  public controller: EasmScanConfigurationAssetGridController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EasmScanConfigurationAssetGridController,
    });
  }
}
